<div class="container">
  <div *ngIf="config?.activatedOffer" class="offer-applied"><span [innerHtml]="util.getCurrencyIcon('INR')?.symbol"></span> {{config?.activatedOffer}} OFFER APPLIED!</div>
  <div class="header">
    <div class="left">
      <div class="title">Social Impact Plan</div>
        <div class="text">Join our community of monthly donors</div>
    </div>
    <div class="right">
      <img src="/assets/images/sip-by-ketto.png" alt="sip-by-ketto" />
    </div>
  </div>
  <div class="payment-form">
    <app-payment-sip [config]="{
      themeColor: '#01BFBD',
      slabTheme: vwo.life_slab_AB() ? 'slab-theme-v6' : 'slab-theme-v2',
      slabsPostLabel: vwo.life_slab_AB() ? 'per month' : '',
      enable_person_based_amount: true,
      show_popular_slab: vwo.life_slab_AB() ? true : false,
      popular_slab_text: vwo.life_slab_AB() ? 'POPULAR' : '',
      formTheme: 'form-theme-v4',
      dialogBtnTheme: 'payment-btn-v1',
      origin: 'rfd',
      showTutorial: false,
      showOptionBackBtn: true,
      disableCard: true
    }">
  </app-payment-sip>
  </div>
</div>